var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Api } from './api';
import * as i0 from "@angular/core";
import * as i1 from "./api";
export class GisToolsApi {
    constructor(api) {
        this.api = api;
        this.districtProperties = 'id, districtNumber, name';
        this.countyProperties = 'id, countyCode, districtNumber, name';
        this.municipalityProperties = 'id, name, municipalityCode, countyCode';
        this.legislativeDistrictProperties = 'id, firstName, lastName, party, counties{id, name}, districts{id}, legislativeDistrictNumber, url, planningPartners{planningPartnerShortName}';
    }
    getDistricts(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.api.http2.graphqlRequest(`query GetDistricts($id: [Int]) {
                districts(id: $id){
                    ${this.districtProperties}
                }
            }`, { id }, 'GET', 'districts');
        });
    }
    getCounties(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.api.http2.graphqlRequest(`query GetCounties($id: [Int]) {
                counties(id: $id){
                    ${this.countyProperties}
                }
            }`, { id }, 'GET', 'counties');
        });
    }
    getCountiesByDistricts(districtNumbers) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.api.http2.graphqlRequest(`query GetCounties($districtNumbers: [String]) {
                counties(districtNumber: $districtNumbers){
                    ${this.countyProperties}
                }
            }`, { districtNumbers }, 'GET', 'counties');
        });
    }
    getMunicipalitiesByCounty(countyCodes) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.api.http2.graphqlRequest(`query GetMunicipalities($countyCodes: [String]) {
            municipalities(countyCode: $countyCodes){
                ${this.municipalityProperties}
            }
        }`, { countyCodes }, 'GET', 'municipalities');
        });
    }
    getCongressionalDistricts(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.api.http2.graphqlRequest(`query GetCongressDistricts($id: [Int]) {
            uscongressionaldistricts(id: $id){
                ${this.legislativeDistrictProperties}
            }
        }`, { id }, 'GET', 'uscongressionaldistricts');
        });
    }
    getSenateDistricts(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.api.http2.graphqlRequest(`query GetSenateDistricts($id: [Int]) {
            pasenatedistricts(id: $id){
                ${this.legislativeDistrictProperties}
            }
        }`, { id }, 'GET', 'pasenatedistricts');
        });
    }
    getHouseDistricts(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.api.http2.graphqlRequest(`query GetHouseDistricts($id: [Int]) {
            pahousedistricts(id: $id){
                ${this.legislativeDistrictProperties}
            }
        }`, { id }, 'GET', 'pahousedistricts');
        });
    }
    getLayerIdByName(name) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.api.http2.graphqlRequest(`query GetLayerIdByName($name: [String]) {
            layers(name: $name, typeId: 1) {
                id
            }
        }`, { name }, 'GET', 'layers');
        });
    }
}
GisToolsApi.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function GisToolsApi_Factory() { return new GisToolsApi(i0.ɵɵinject(i1.Api)); }, token: GisToolsApi, providedIn: "root" });
